<template>
  <div v-if="visible" class="popup-modal">
    <div class="popup-content mainland-popup">
      <span class="popup-close" @click="$emit('close')">&times;</span>
      <div class="popup-modal-title mainland-title">付款</div>
      <div class="popup-modal-desc mainland-desc">
        <span class="payment-icon">
          <img src="/ssr/img/payment/alipay.svg" alt="支付宝" class="payment-method-icon">
        </span>支付宝 或
        <span class="payment-icon">
          <img src="/ssr/img/payment/wechat.svg" alt="微信支付" class="payment-method-icon">
        </span>微信支付 只能用于一次性购买，无法进行连续订阅。
        如果打开的购买页面中未出现支付宝或微信支付的选项，可能是由于你的IP地址不在允许的国家或地区范围内。
      </div>
      <div class="payment-options">
        <div class="payment-title">请选择你要购买的方案：</div>
        <div class="payment-plan-list">
          <label v-for="(plan, index) in paymentPlans" :key="index" class="plan-option">
            <input 
              type="radio" 
              :value="plan.id" 
              v-model="selectedPlan"
              name="payment-plan"
            >
            <span class="plan-label">{{ plan.label }}</span>
          </label>
        </div>
      </div>
      <button class="popup-btn mainland-btn" @click.prevent="handleContinue">继续</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupMainland',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 添加新的 prop
    onCheckout: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      selectedPlan: null,
      paymentPlans: [
        { id: 'starter_onepay_month', type_name: 'starter_onepay_month', label: '入门版 - 单月 (¥48元)' },
        { id: 'pro_onepay_month', type_name: 'pro_onepay_month', label: '专业版 - 单月 (¥138元)' },
        { id: 'starter_onepay_year', type_name: 'starter_onepay_year', label: '入门版 - 整年(50% OFF) (¥398元)' },
        { id: 'pro_onepay_year', type_name: 'pro_onepay_year', label: '专业版- 整年(60%OFF) (¥998元)' }
      ]
    }
  },
  methods: {
    handleContinue() {
      if (this.selectedPlan) {
        const selectedPlanData = this.paymentPlans.find(plan => plan.id === this.selectedPlan);
        this.onCheckout(selectedPlanData);
        // this.$emit('continue', this.selectedPlan)
      }
    }
  }
}
</script>

<style scoped>
/* 基础弹窗样式优化 */
.mainland-popup {
  max-width: 480px;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #ffffff;
  text-align: left;
}

/* 标题样式优化 */
.mainland-title {
  margin: 0 0 22px;
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: center;
  position: relative;
  padding-bottom: 12px;
}

.mainland-title:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background: linear-gradient(90deg, #ff6b6b, #a66cff);
  border-radius: 3px;
}

/* 描述文本样式优化 */
.mainland-desc {
  color: #666;
  line-height: 1.6;
  margin: 0 0 24px;
  font-size: 14px;
  background: #f8f9fa;
  padding: 14px;
  border-radius: 12px;
  border-left: 4px solid #4481eb;
}

/* 支付图标样式优化 */
.payment-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 4px;
  vertical-align: middle;
}

.payment-method-icon {
  width: 18px;
  height: 18px;
  transition: transform 0.3s ease;
}

.payment-icon:hover .payment-method-icon {
  transform: scale(1.2);
}

/* 付款选项标题样式 */
.payment-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 14px;
  position: relative;
}

/* 计划列表样式优化 */
.payment-plan-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #f8f9fa;
  padding: 14px;
  border-radius: 12px;
  margin-bottom: 24px;
}

.plan-option {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  background: white;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.plan-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 0, 0, 0.12);
}

/* 自定义单选按钮样式 */
.plan-option input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 50%;
  outline: none;
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.plan-option input[type="radio"]:checked {
  border-color: #4481eb;
}

.plan-option input[type="radio"]:checked::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4481eb;
}

/* 计划标签样式 */
.plan-label {
  font-size: 14px;
  color: #333;
  flex: 1;
  line-height: 1.4;
  display: block;
  word-break: break-word;
}

/* 突出显示年度优惠信息 */
.plan-option:nth-child(3) .plan-label,
.plan-option:nth-child(4) .plan-label {
  position: relative;
  padding-right: 6px;
}

.plan-option:nth-child(3) .plan-label::after,
.plan-option:nth-child(4) .plan-label::after {
  content: "优惠";
  position: absolute;
  right: -8px;
  top: -10px;
  background: #ff6b6b;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: 600;
}

/* 继续按钮样式优化 */
.mainland-btn {
  width: 100%;
  padding: 12px 0;
  margin: 0 auto;
  font-size: 15px;
  font-weight: 600;
  border-radius: 10px;
  background: linear-gradient(135deg, #4481eb, #04befe);
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(68, 129, 235, 0.25);
}

.mainland-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(68, 129, 235, 0.35);
}

.mainland-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 10px rgba(68, 129, 235, 0.2);
}

.mainland-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,0.2), rgba(255,255,255,0));
  transition: left 0.7s ease;
}

.mainland-btn:hover::before {
  left: 100%;
}

/* 关闭按钮样式优化 */
.popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #666;
  background: #f0f2f5;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 5;
}

.popup-close:hover {
  background: #e4e6eb;
  color: #333;
  transform: rotate(90deg);
}

/* 响应式调整 - 更多断点和优化 */
@media (max-width: 520px) {
  .mainland-popup {
    padding: 22px 18px;
    width: 92%;
    max-width: none;
    border-radius: 14px;
  }
  
  .mainland-title {
    font-size: 18px;
    margin-bottom: 18px;
    padding-bottom: 10px;
  }
  
  .mainland-desc {
    font-size: 13px;
    padding: 12px;
    margin-bottom: 20px;
    line-height: 1.5;
    border-left-width: 3px;
  }
  
  .payment-title {
    font-size: 15px;
    margin-bottom: 12px;
  }
  
  .payment-plan-list {
    padding: 12px;
    gap: 8px;
    margin-bottom: 20px;
  }
  
  .plan-option {
    padding: 10px 12px;
  }
  
  .plan-label {
    font-size: 13px;
  }
  
  .mainland-btn {
    padding: 12px 0;
    font-size: 14px;
    border-radius: 8px;
  }
  
  .payment-method-icon {
    width: 16px;
    height: 16px;
  }
}

/* 特小屏幕设备优化 */
@media (max-width: 360px) {
  .mainland-popup {
    padding: 18px 15px;
    width: 94%;
  }
  
  .mainland-title {
    font-size: 16px;
    margin-bottom: 16px;
  }
  
  .mainland-desc {
    font-size: 12px;
    padding: 10px;
    margin-bottom: 18px;
  }
  
  .payment-title {
    font-size: 14px;
    margin-bottom: 10px;
  }
  
  .payment-plan-list {
    padding: 10px;
    gap: 8px;
  }
  
  .plan-option {
    padding: 8px 10px;
  }
  
  .plan-option input[type="radio"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  
  .plan-option input[type="radio"]:checked::before {
    width: 7px;
    height: 7px;
  }
  
  .plan-label {
    font-size: 12px;
  }
  
  .plan-option:nth-child(3) .plan-label::after,
  .plan-option:nth-child(4) .plan-label::after {
    font-size: 10px;
    padding: 1px 4px;
    right: -6px;
    top: -8px;
  }
  
  .mainland-btn {
    padding: 10px 0;
    font-size: 13px;
  }
  
  .popup-close {
    width: 24px;
    height: 24px;
    font-size: 18px;
    top: 10px;
    right: 10px;
  }
}

/* 处理横屏模式 */
@media (max-height: 500px) and (orientation: landscape) {
  .popup-modal {
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
    overflow-y: auto;
  }
  
  .mainland-popup {
    max-height: 90vh;
    overflow-y: auto;
    padding: 16px;
  }
  
  .mainland-title {
    font-size: 16px;
    margin-bottom: 15px;
    padding-bottom: 8px;
  }
  
  .mainland-desc {
    margin-bottom: 15px;
    max-height: 80px;
    overflow-y: auto;
    font-size: 12px;
    padding: 8px;
  }
  
  .payment-plan-list {
    max-height: 160px;
    overflow-y: auto;
    margin-bottom: 15px;
  }
  
  .plan-option {
    padding: 8px 10px;
  }
  
  .plan-label {
    font-size: 12px;
  }
  
  .mainland-btn {
    padding: 8px 0;
    font-size: 13px;
  }
}

/* 确保弹窗在任何设备上都可以完整查看 */
@media (max-height: 600px) {
  .popup-modal {
    align-items: flex-start;
    padding: 20px 10px;
  }
  
  .mainland-popup {
    margin: 0;
    max-height: 95vh;
    overflow-y: auto;
  }
}
</style>

    overflow-y: auto;